import {inject, Injectable} from '@angular/core';
import {UrlTree} from '@angular/router';
import {filter, map, Observable, withLatestFrom} from 'rxjs';
import {Store} from '@ngrx/store';
import {PatronSelectors} from '@store/store.selectors';
import {PatronActions} from '@store/patron/patron.actions';

@Injectable({
  providedIn: 'root'
})
export class PartialAuthGuard {
  private readonly store = inject(Store);

  // This guard catches patrons who are logged in with their library card number and pin.
  // This is only allowed in register-existing-card, otherwise log out these auths.
  public canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(PatronSelectors.Auth.finishedLoading).pipe(
      filter((loaded) => loaded),
      withLatestFrom(this.store.select(PatronSelectors.Auth.hasPatron), this.store.select(PatronSelectors.Auth.googleUid)),
      map(([, hasPatron, googleUid]) => {
        if (hasPatron && !googleUid) {
          this.store.dispatch(PatronActions.logoutPatron());
        }
        return true;
      })
    );
  }
}
